import { PermissionList, RolePermission, staffStatusEnums, User } from '../../utils';

export const SERVICE = 'SERVICE';
export const STAFF = 'STAFF';
export const BREAK = 'BREAK';
export const DRIVE = 'DRIVE';
export const UNAVAILABLE = 'UNAVAILABLE';
export const PAID = 'PAID';
export const UNPAID = 'UNPAID';
export const SICK_TIME = 'SICK_TIME';

export function getDisplayFromType(givenType = '') {
    switch (givenType) {
        case SERVICE:
            return 'Service';
        case STAFF:
            return 'Staff';
        case BREAK:
            return 'Break';
        case DRIVE:
            return 'Drive';
        case PAID:
            return 'Paid';
        case UNPAID:
            return 'Unpaid';
        case UNAVAILABLE:
            return 'Block Time (Unavailable)';
        default:
            return '';
    }
}

export function getDisplayFromFullType(givenType = '') {
    switch (givenType) {
        case SERVICE:
            return 'Service Appt';
        case STAFF:
            return 'Staff Appt';
        case BREAK:
            return 'Break';
        case DRIVE:
            return 'Drive Time';
        case PAID:
            return 'Paid Time Off';
        case UNPAID:
            return 'Unpaid Time Off';
        case SICK_TIME:
            return 'Sick Type';
        case UNAVAILABLE:
            return 'Unavailable';
        default:
            return '';
    }
}

export const billStatuses = {
    BILLED: 'BILLED',
    NOT_BILLED: 'NOT_BILLED',
    ON_CLAIM: 'ON_CLAIM',
};

export const scheduleStatuses = {
    COMPLETED: 'COMPLETED',
    RENDER: 'RENDER',
    CANCELLED: 'CANCELLED',
    PENDING: 'PENDING',
};

/**
 * Status-filter value for service appts with no staff yet (API `ApptStatusFilter.UNASSIGNED`). Not a stored
 * status: with it as its own option, "Pending" means pending appts that have a staff.
 */
export const UNASSIGNED_STATUS = 'UNASSIGNED';

/**
 * A service appt with no staff yet. Stored as PENDING with no `staff`; shown as "Unassigned" and can't be
 * started, rendered or billed until staff is assigned (the API enforces it too).
 */
export const isUnassignedAppt = (item) => item?.type === SERVICE && item?.status === scheduleStatuses.PENDING && !item?.staff;

export const apptActionNames = {
    EDIT: 'EDIT',
    DUPLICATE: 'DUPLICATE',
    CHECK: 'CHECK',
};

export function diff_minutes(times) {
    if (times.startTime && times.endTime) {
        let dt1 = new Date(times.startTime);
        let dt2 = new Date(times.endTime);
        let diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    }
}

export const TELEHEALTH_PROVIDERS = {
    ZOOM: 'ZOOM',
    GOOGLE_MEET: 'GOOGLE_MEET',
};

export const RENDER_APPOINTMENTS_LIST = 'RENDER_APPOINTMENTS_LIST';

export const localSaveScheduleDates = (params) => {
    sessionStorage.setItem('apptDates', JSON.stringify(params));
};

export const checkCreateApptPermissions = (userInfo) => {
    return RolePermission([
        PermissionList.APPT_SERVICE_CREATE?.code,
        PermissionList.APPT_CONNECTED_CREATE?.code,
        PermissionList.APPT_DRIVE_CREATE?.code,
        PermissionList.APPT_BREAK_CREATE?.code,
        PermissionList.APPT_PTO_CREATE?.code,
        PermissionList.APPT_STAFF_CREATE?.code,
        PermissionList.APPT_SELF_CREATE?.code,
        PermissionList.APPT_SICK_TIME_CREATE?.code,
    ]);
    // ]) && userInfo?.status === staffStatusEnums?.ACTIVE
};
